import React from 'react'
import { Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules'
import { Swiper, SwiperSlide } from 'swiper/react'
import { SwiperProps } from 'swiper/react';

type Props = {
    data: { content: React.ReactNode }[];
    slidesPerView?: number;
    classNameSlide?: string;
    breakpoints?: SwiperProps['breakpoints'];
}
const SwiperCustom: React.FC<Props> = ({ data, slidesPerView = 1, classNameSlide, breakpoints }: Props) => {

    return (
        <Swiper
            modules={[Navigation, Pagination, Scrollbar, A11y]}
            spaceBetween={50}
            slidesPerView={slidesPerView}
            navigation={{
                enabled: true,
                nextEl: '.custom-next-button',
                prevEl: '.custom-prev-button',
            }}
            breakpoints={breakpoints}
            pagination={{
                clickable: true,
            }}
            scrollbar={{ draggable: true }}
            className="w-full h-full"   // ⬅️ ให้ swiper ยืดเต็ม parent
        >
            {data?.map((list, i) => {
                return (
                    <SwiperSlide className={classNameSlide} key={i}>
                        {list.content}
                    </SwiperSlide>
                )
            })}
        </Swiper>
    )
}

export default SwiperCustom